import { render, staticRenderFns } from "./BlockoutPeriod.vue?vue&type=template&id=73cd82fe&"
import script from "./BlockoutPeriod.vue?vue&type=script&lang=ts&"
export * from "./BlockoutPeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports